import React from 'react';
import { withRouter } from 'react-router-dom';

import Sentry from '../../../sentry';
import Config from '../../../config';
import localStorage from '../../../local-storage';

const SignOutIcon = require('modules/assets/web/icon_signout.png');

class SignOutButton extends React.Component {
  handleClick = () => {
    // console.devLog.info('execute signed out');
    localStorage.removeItem(Config.LOCAL_STORAGE_AUTH_KEY);
    Sentry.setUser(); // Remove user context after signing out
    this.props.history.push('signin');
  };

  render() {
    return (
      <button
        className="nav-link btn btn-link text-white"
        href="#"
        onClick={this.handleClick}
      >
        {Config.IS_CLIENT_APP ? <img alt="sign out" src={SignOutIcon} /> : null}
        Sign out
      </button>
    );
  }
}

export default withRouter(SignOutButton);
